import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    askForHelp: 'Request my certificate by mail',
    ctaButton: 'OK, I understand',
    descriptionForNonMandatee:
      'If you want, the original deposit certificate can be sent by post for a physical registration with the authorized commercial court.',
    priceInfo: 'The shipping cost will be € 5 plus tax.',
    title: 'We will send you an electronic deposit certificate',
    warning:
      'This electronic certificate is valid for creating your company online on the Guichet Unique',
  },
  fr: {
    askForHelp: 'Demander mon certificat par courrier',
    ctaButton: 'C’est compris',
    descriptionForNonMandatee:
      'Si vous le souhaitez, le certificat de dépôt original peut vous être envoyé par courrier.',
    priceInfo: 'Le montant de l’envoi vous sera facturé 5 € HT.',
    title: 'Nous vous enverrons un certificat de dépôt électronique',
    warning:
      'Ce certificat électronique est valable pour une création de société en ligne sur le Guichet Unique',
  },
} as const);
